export default 'https://tme.understood.org/assets/background.4114c896.glb'